/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext } from "react";
import { Login as LoaderLogIn, LoginIcon, Layout as LoaderLayout, AppContext } from '@ctsu/loader';
import { Navigate } from 'react-router-dom';
import { k } from '../assets/text';
import { ShowPublicNotifications } from '@ctsu/react-ctsu-ui';
// import LoginLayout from './LoginLayout';

function AboutProtocolDeviationsWelcomeMessage() {
  return (
    <div className="col-12 mr-4">
      <div
        className="app-welcome-title color-blue"
        role="heading"
        aria-level="2"
      >
        {k.WELCOME}
      </div>
      <div className="font-lg color-dark-grey" style={{ lineHeight: '1.6' }}>
        <p className="my-3">
          {k.THE} <span className="font-bold">{k.PROTOCOL_DEVIATIONS}</span>{' '}
          {k.APPLICATION_SUPPORTS_THE_MAINT}
        </p>
      </div>
    </div>
  );
}

export default function Login(redirectParams) {
  const context = useContext(AppContext);
  const params = new URLSearchParams(window.location.search);
  const redirectTo = redirectParams.page.props.to || params.get('redirectTo') || '/';
  const appName = process.env.REACT_APP_NAME;
  const appOrigin = process.env.REACT_APP_ORIGIN;
  const relayState = process.env.REACT_APP_RELAY_STATE;
  return (
    <div>
      <div>
        <ShowPublicNotifications
          appName={`${process.env.REACT_APP_NAME}`}
          appOrigin={`${process.env.REACT_APP_ORIGIN}`}
          coreVersion={`${process.env.REACT_APP_PERSON_API_VERSION}`}
          context={context}
        />
      </div>
      <LoaderLayout
        welcomeMessage="Welcome to Protocol Deviations Application"
        aboutSection={AboutProtocolDeviationsWelcomeMessage()}
         loginAction={   <LoaderLogIn
          page={<Navigate to={redirectTo} />}
          appName={appName}
          appOrigin={appOrigin}
          relayState={relayState}
          buttonText="Login"
          loadingText="Logging in..."
          buttonIcon={<LoginIcon />}
          buttonClassName="btn turquoise font-lg padded"
          buttonTooltip="Login with CTEP-IAM"
          iconPosition="right"
          onError={(error) => console.log(error)}
        />}>
     
      </LoaderLayout>
    </div>
  );
}
